module.exports = __webpack_public_path__ + "img/Animales-GAFAS.9ea37856.png";